
import React, { Component } from 'react';
import animateScrollTo from 'animated-scroll-to';
import Button from '../../../common/button/Button';

const dataSiteMap = require('./dataSiteMap.json');

class SiteMap extends Component {
    componentDidMount() {
        animateScrollTo(0, { speed: 700 });
    }

    _mapData = () => Object.entries(dataSiteMap).map((siteMapPoints, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className="box">
            <h2>
                {siteMapPoints[0]}
            </h2>
            <ul>
                {
                    siteMapPoints[1].map((siteMapPoint) => (
                        <li key={siteMapPoint.name}>
                            <Button className="btnList" title={siteMapPoint.name} to={siteMapPoint.to}>
                                {siteMapPoint.name}
                            </Button>
                        </li>
                    ))
                }
            </ul>
        </div>
    ))

    render() {
        return (
            <section className="tw-container tw-m-auto tw-px-5 sectionSiteMap">
                <div className="tw-text-center tw-my-10 lg:tw-mt-0">
                    <h1 className="tw-mb-2">Sitemap</h1>
                    <p>Use o mapa do site para se informar e ouvir o melhor da música internacional</p>
                </div>

                <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-10">
                    {this._mapData()}
                </div>
            </section>
        );
    }
}

export default SiteMap;
